var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 1.75H1.75V24.5C1.75 24.9641 1.93437 25.4092 2.26256 25.7374C2.59075 26.0656 3.03587 26.25 3.5 26.25H26.25V24.5H3.5V1.75Z",
    fill: "#1076BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 7.875H20.125V9.625H23.2663L16.625 16.2663L12.8713 12.5037C12.7899 12.4217 12.6931 12.3566 12.5865 12.3122C12.4799 12.2678 12.3655 12.2449 12.25 12.2449C12.1345 12.2449 12.0201 12.2678 11.9135 12.3122C11.8069 12.3566 11.7101 12.4217 11.6287 12.5037L5.25 18.8913L6.48375 20.125L12.25 14.3587L16.0038 18.1212C16.0851 18.2033 16.1819 18.2684 16.2885 18.3128C16.3951 18.3572 16.5095 18.3801 16.625 18.3801C16.7405 18.3801 16.8549 18.3572 16.9615 18.3128C17.0681 18.2684 17.1649 18.2033 17.2462 18.1212L24.5 10.8587V14H26.25V7.875Z",
    fill: "#1076BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.9eb6853fa282a0ddfd2c2ef713414f46.svg";
export { ForwardRef as ReactComponent };